export * from './ComparisonTable';

import { ComparisonTable } from './ComparisonTable';

export default ComparisonTable;
